import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const adminSettingsApi = createApi({
    reducerPath: "adminSettings",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['adminSettings'],
    endpoints: (builder) => ({

        getPrivacyPolicy: builder.query({
            query: () => ({
                url: `settings/privacy-policy`,
                method: "GET",
            }),
            transformResponse: (res) => res.data,
            providesTags: ['adminSettings']
        }),

        getAboutUs: builder.query({
            query: () => ({
                url: `settings/about-us`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
            providesTags: ['adminSettings']
        }),

        getTermsConditions: builder.query({
            query: () => ({
                url: `settings/terms-conditions`,
                method: "GET",
            }),
            transformResponse: (res) => res.data,
            providesTags: ['adminSettings']
        }),

        getAdminLegal: builder.query({
            query: ({ type }) => ({
                url: `/admin/legal?type=${type}`,
                method: "GET",
            }),
            transformResponse: (res) => res?.body,
            providesTags: ['adminSettings']
        }),

        updateSetting: builder.mutation({
            query: ({ _id, data }) => ({
                url: `/admin/legal`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['adminSettings'],
        }),
        getAboutUsInHome: builder.query({
            query: () => ({
                url: `/contractor/about`,
                method: "GET",
            }),
        }),
        getPrivacyPolicyInHome: builder.query({
            query: () => ({
                url: `contractor/privacy`,
                method: "GET",

            })
        }),
        getTermsConditionsInHome: builder.query({
            query: () => ({
                url: `contractor/terms`,
                method: "GET",

            })
        }),
        updateAcceptTerms: builder.mutation({
            query: (data) => ({
                url: `/contractor/accept-terms`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['adminSettings'],
        }),
    }),
});

export const {
    useGetPrivacyPolicyQuery,
    useGetAboutUsQuery,
    useGetTermsConditionsQuery,
    useUpdateSettingMutation,
    useGetAdminLegalQuery,
    useGetAboutUsInHomeQuery,
    useGetPrivacyPolicyInHomeQuery,
    useUpdateAcceptTermsMutation,
    useGetTermsConditionsInHomeQuery
} = adminSettingsApi;